var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.authenticated)?_c('Unauthenticated'):_vm._e(),(_vm.authenticated)?_c('Authenticated'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }